import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Row, Col } from 'react-bootstrap';
import { FormikInput } from '../../../components';
import { QuestionDescriptionFields, ScaleSelect } from './EvaluationScaleShared';
import { LIKERT_N_OPTIONS, makeSimpleChoices } from '../EvaluationScaleConfig';

export const LikertScaleLayout = ({ valuePath, questionChoicesAttributes = [] }) => {
  const { setFieldValue } = useFormikContext();
  const visibleChoices = questionChoicesAttributes.filter(c => !c._destroy);
  const n = visibleChoices.length || 2;

  const handleNChange = val => {
    setFieldValue(`${valuePath}[questionChoicesAttributes]`, makeSimpleChoices(parseInt(val, 10)));
  };

  return (
    <div className="mt-3">
      <QuestionDescriptionFields valuePath={valuePath} descriptionPlaceholder="Seleccione una opción" />
      <ScaleSelect label="N° de Opciones" options={LIKERT_N_OPTIONS} value={n} onChange={handleNChange} />
      <Row>
        <Col>
          <p className="text-muted mb-1">
            Respuesta: <span className="eval-scale-preview-hint">(Vista Previa)</span>
          </p>
          <div className="eval-likert-row">
            {visibleChoices.map((choice, idx) => {
              const realIdx = questionChoicesAttributes.indexOf(choice);
              return (
                <div key={choice.id || choice.position} className="eval-likert-item">
                  <Field name={`${valuePath}[questionChoicesAttributes][${realIdx}][label]`}>
                    {({ field }) => (
                      <FormikInput
                        {...field}
                        value={field.value || ''}
                        maxLength={25}
                        placeholder={`Opción ${idx + 1}`}
                        customFormGroupClass="eval-likert-label-input mb-0"
                      />
                    )}
                  </Field>
                </div>
              );
            })}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LikertScaleLayout;
